import React, { useState, useContext } from "react";
import { LangContext } from "../../../../context/DataContext";
import { NavLink } from "react-router-dom";
import { reportData } from "../../../../data/report-data/report-data/reportData";
import slugify from 'react-slugify';

// Agrupación de reportes por categoría
export const reportsByCategory = {
    ciberseguridad: [
        'investigacionAtaquesDdos',
        'antiSpoofing',
        'vulnerabilidadAtaquesDdos',
        'dnsOpenResolversIPv4Data',
        'ataquesDdosComoMitigarlos',
        'unaHistoriaDeExitoEnCiberseguridad'
    ],
    interconexion: [
        'interconexionBgp',
        'conectividad2020',
        'optimizacionRedesBgp',
        'interconexionBgpLocal',
        'rootServerLocal',
        'dnsOverTls',
        'mejoresPracticasIxp',
        'conectividadEnLac',
        'tiempoNubeAnycastLactldLac',
        'seguridadRuteoLac'
    ],
    ipv6: [
        'soporteIPv6EnEquiposCPE2020',
        'tendenciasIPv62016',
        'operadoresDespliegueIPv6',
        'soporteIPv6EnEquiposCPE2021'
    ]
};

// Traducciones de las categorías
const categoryTranslations = {
    ciberseguridad: {
        es: 'Ciberseguridad',
        en: 'Cybersecurity',
        pt: 'Cibersegurança'
    },
    interconexion: {
        es: 'Interconexión',
        en: 'Interconnection',
        pt: 'Interconexão'
    },
    ipv6: {
        es: 'IPv6',
        en: 'IPv6',
        pt: 'IPv6'
    }
};

export default function MainSidebar({ category, routes = {}, lang }) {
    const [clickMenu, setClickMenu] = useState(category);
    const { myLang } = useContext(LangContext);

    // Función para asegurar que siempre tengamos un idioma válido
    const getValidLang = () => {
        const validLangs = ['es', 'en', 'pt'];
        return validLangs.includes(lang) ? lang : myLang || 'es';
    };

    // Función para obtener la ruta correcta según el idioma
    const getRoutePath = (categoryKey, title) => {
        const currentLang = getValidLang();
        const categoryPaths = {
            es: {
                ciberseguridad: 'ciberseguridad',
                interconexion: 'interconexion',
                ipv6: 'ipv6'
            },
            en: {
                ciberseguridad: 'cybersecurity',
                interconexion: 'interconnection',
                ipv6: 'ipv6'
            },
            pt: {
                ciberseguridad: 'ciberseguranca',
                interconexion: 'interconexao',
                ipv6: 'ipv6'
            }
        };

        const categoryPath = routes[categoryKey] || categoryPaths[currentLang][categoryKey];
        return `/${currentLang}/${categoryPath}/${slugify(title)}`;
    };

    const renderCategory = (categoryKey) => {
        const reports = reportsByCategory[categoryKey];
        if (!reports) return null;

        const currentLang = getValidLang();

        return (
            <div key={categoryKey}>
                <button 
                    onClick={() => setClickMenu(categoryKey)}
                    className={clickMenu === categoryKey ? 'arrow_rotate' : null}
                >
                    {categoryTranslations[categoryKey][currentLang]} <i className="fas fa-angle-down" />
                </button>
                <ul className={clickMenu === categoryKey ? 'active' : null}>
                    {reports.map(reportId => {
                        const report = reportData[reportId];
                        if (!report) return null;

                        // Obtener el título en el idioma correcto con fallback a español
                        const title = report[currentLang]?.title || report.es.title;
                        
                        return (
                            <li key={reportId}>
                                <NavLink to={getRoutePath(categoryKey, title)}>
                                    {title}
                                </NavLink>
                            </li>
                        );
                    })}
                </ul>
            </div>
        );
    };

    return (
        <nav>
            {Object.keys(reportsByCategory).map(categoryKey => 
                renderCategory(categoryKey)
            )}
        </nav>
    );
}